import type { StoreActionApi } from 'react-sweet-state';
import type { State } from '../types';

export const clearConversation =
    () =>
    ({ setState }: StoreActionApi<State>) => {
        setState({ messages: [], conversationId: undefined, isLoading: false });
    };
